// team/shared/components/TeamIconComponent.js
import React from 'react';
import { Box } from '@mui/material';
import { getIconComponent } from 'utils/icons/iconUtils';

const TeamIconComponent = ({
    name,
    size = '1.25rem',
    marginRight = '1rem',
    grayscale = true,
    sx = {}
}) => {
    const IconComponent = getIconComponent(name);

    if (!IconComponent) return null;

    return (
        <Box sx={{
            width: size,
            height: size,
            filter: grayscale ? 'grayscale(100%) brightness(1.2)' : 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: marginRight,
            flexShrink: 0,
            ...sx
        }}>
            <IconComponent sx={{
                width: '100%',
                height: '100%'
            }} />
        </Box>
    );
};

export default TeamIconComponent;